const planBtn = (() => {
  const pagePlan = (document.getElementById("pagePlan") != null);
  if (pagePlan) {



    let sW = window.innerWidth;


    const secPlan = document.getElementById('jsSecPlan');
    const planWraps = secPlan.querySelectorAll('.js-plan-wrap');


    if (sW > 750) {

      planWraps.forEach((element, index) => {
        let bgArea = element.querySelector('.js-bg-area');
        let bgBoxs = bgArea.querySelectorAll('.js-bg-box');
        let typeArea = element.querySelector('.js-type-area');
        let typeBoxs = typeArea.querySelectorAll('.js-type-box');
        let dataArea = element.querySelector('.js-data-area');
        let dataBoxs = dataArea.querySelectorAll('.js-data-box');
        let labelArea = element.querySelector('.js-label-area');
        let labelBoxs = labelArea.querySelectorAll('.js-label-box');
        let linkArea = element.querySelector('.js-link-area');
        let linkBoxs = linkArea.querySelectorAll('.js-link-box');

        linkBoxs.forEach((elem, i) => {

          elem.addEventListener('mouseover', () => {
            bgBoxs[i].classList.add('hover')
            typeBoxs[0].classList.add('hover')
            dataBoxs[i].classList.add('hover')
            labelBoxs[i].classList.add('hover')
          });

          elem.addEventListener('mouseleave', () => {
            bgBoxs[i].classList.remove('hover')
            typeBoxs[0].classList.remove('hover')
            dataBoxs[i].classList.remove('hover')
            labelBoxs[i].classList.remove('hover')
          });
        });

      });

    }



  }
})();
export default planBtn;